import { useEffect, useEffectEvent, useState } from "react";
import { useDebouncedValue } from "@/shared/hooks/useDebouncedValue";
import { cx } from "@/shared/lib/cx";
import { Icon } from "../Icon";

/** Search box that reports its value only after typing pauses (fewer API calls). */
export function SearchInput({ value, onSearch, placeholder = "Tìm…", delay = 300, width = "lg" }: {
  value: string; onSearch: (q: string) => void; placeholder?: string; delay?: number; width?: "sm" | "md" | "lg";
}) {
  const [text, setText] = useState(value);
  const debounced = useDebouncedValue(text, delay);
  // Only react to the user's typing, not to the parent echoing it back.
  const report = useEffectEvent((q: string) => { if (q !== value) onSearch(q); });
  useEffect(() => report(debounced), [debounced]);
  return (
    <div className={cx("input-wrap", text && "has-trail", `w-${width}`)}>
      <Icon name="search" size={16} className="input-lead" />
      <input
        type="search" className="input" placeholder={placeholder} value={text} aria-label={placeholder}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Escape" && text) { e.preventDefault(); setText(""); } }}
      />
      {text && (
        <button type="button" className="btn btn-ghost btn-sm btn-icon input-trail" aria-label="Xoá tìm kiếm" onClick={() => setText("")}>
          <Icon name="x" size={14} />
        </button>
      )}
    </div>
  );
}
